export const importMap = {
    Search: () => import('./components/Search')
};